import React from "react";
import { Snackbar, Alert, Slide } from "../../styles/MaterialUI";

const CustomToasts = ({ toastInfo, onClose }) => {
  return (
    <>
      <Snackbar
        key={toastInfo.id ?? toastInfo.message}
        open={toastInfo.isOpen}
        autoHideDuration={5000}
        onClose={() => onClose()}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={(props) => <Slide {...props} direction="down" />}
      >
        <Alert variant="filled" severity={toastInfo.severity} onClose={() => onClose()}>
          {toastInfo.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CustomToasts;
